import * as angular from "angular";
import { ToastUtils } from "../../helper/toast.helper";
import { DialogUtils } from "../../helper/dialog.helper";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { CustomFieldAttachmentModel } from "../../models/custom-field-attachment.model";
import { HouseOccupant } from "../../models/house-occupant.model";

let CustomFieldAttachmentChipsComponent = {
    selector: "vcCustomFieldAttachmentChips",
    templateUrl:
        "/angular/components/custom-fields/custom-field-attachment-chips.component.html",
    bindings: {
        cfid: "=",
        houseoccupant: "=",
        files: "=",
        removable: "=?",
        downloadable: "=?",
        clickable: "=",
        max: "=?",
    },
    controller: class CustomFieldAttachmentChips {
        // * bindings for typescript compiler *
        public files?: CustomFieldAttachmentModel[];
        public houseoccupant: HouseOccupant;
        public cfid: number;
        public removable: boolean;
        public downloadable: boolean;
        public clickable: boolean;
        public max?: number;
        // ************************************

        public $scope: any;
        public toast: ToastUtils;
        public dialog: DialogUtils;
        public $timeout: any;
        public dataProvider: FieldDataProvider;
        public isLeaderView: boolean;
        public nonDeletedFiles: CustomFieldAttachmentModel[];

        constructor(
            $scope: any,
            $timeout: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            FieldDataProvider: FieldDataProvider,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.dataProvider = FieldDataProvider;
            this.isLeaderView = __app_type == "LEADER";

            this.$scope.$watch(
                () => this.files,
                (
                    newValue: string | number,
                    oldValue: string | number
                ): void => {
                    this.setNonDeletedFiles();
                },
                true
            );
        }

        $onInit() {
            this.removable = this.removable ?? false;
            this.downloadable = this.downloadable ?? true;
            this.max = this.max ?? null;

            if (this.files && (!this.max || this.files.length <= this.max)) {
                angular.forEach(this.files, (file: CustomFieldAttachmentModel) => {
                    this.dataProvider
                        .getAttachment({ id: file.cfoid })
                        .then((attachment: CustomFieldAttachmentModel) => {
                            file.setData(attachment);
                        });
                });
            }
            this.setNonDeletedFiles();
        }
        viewCustomFieldAttachment(
            file: CustomFieldAttachmentModel,
            ev: any
        ): void {
            this.dialog.show({
                component: "vc-view-custom-field-attachment",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "x-large",
                locals: {
                    file: file,
                    houseoccupant: this.houseoccupant,
                },
            });
        }

        viewMultipleCustomFieldAttachments(ev: any): void {
            this.dialog.show({
                component: "vc-view-multiple-custom-field-attachments",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    houseoccupant: this.houseoccupant,
                    cfid: this.cfid,
                },
            });
        }

        setNonDeletedFiles(): void {
            if (!this.files) return;
            this.nonDeletedFiles = this.files.filter(
                (file: CustomFieldAttachmentModel) => {
                    return !file.status || file.status != "Deleted";
                }
            );
        }

        downloadAttachment(file: CustomFieldAttachmentModel, ev: any): void {
            ev.preventDefault();
            this.dataProvider
                .getAttachment(file.cfoid)
                .then((attachment: CustomFieldAttachmentModel) => {
                    window.location.assign(attachment.url);
                });
        }

        deleteAttachment(file: CustomFieldAttachmentModel, ev: any): void {
            ev.preventDefault();
            file.status = "Deleted";
            if (!file.hocfid) {
                let index: number = this.files.indexOf(file);
                this.files.splice(index, 1);
            }

            this.setNonDeletedFiles();
        }
    },
};

angular
    .module("customField")
    .component(
        CustomFieldAttachmentChipsComponent.selector,
        CustomFieldAttachmentChipsComponent
    );
